module.exports = __webpack_public_path__ + "img/elmire.f3b83487.svg";